export interface PersonResult {
  id: string;
  displayName: string;
  jobTitle?: string;
  department?: string;
}

export interface PersonProfile {
  id: string;
  displayName: string;
  jobTitle?: string;
  department?: string;
  officeLocation?: string;
  mobilePhone?: string;
  businessPhones?: string[];
  mail?: string;
  userPrincipalName?: string;
}

export async function searchPeople(query: string): Promise<PersonResult[]> {
  if (!query || query.length < 2) return [];
  const r = await fetch(`/api/people-search?q=${encodeURIComponent(query)}`);
  if (!r.ok) {
    console.error("people-search HTTP error:", r.status);
    return [];
  }
  const contentType = r.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    console.error("people-search returned non-JSON:", contentType, await r.text().then(t => t.slice(0, 200)));
    return [];
  }
  const body = (await r.json()) as { results: PersonResult[]; error?: string };
  if (body.error) console.error("people-search API error:", body.error);
  return body.results ?? [];
}

export async function getPersonProfile(id: string): Promise<PersonProfile | null> {
  const r = await fetch(`/api/people-profile/${encodeURIComponent(id)}`);
  if (!r.ok) return null;
  return r.json();
}

export function photoUrl(id: string): string {
  return `/api/people-photo/${encodeURIComponent(id)}`;
}
